import React, { useState } from 'react';
import emailService from '../services/emailService';
import notificationService from '../services/notificationService';
import './AboutPage.css';
import { Link } from 'react-router-dom';

const AboutPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form data
    const validation = emailService.validateContactForm(formData);
    if (!validation.isValid) {
      validation.errors.forEach(error => {
        notificationService.error('Validation Error', error);
      });
      return;
    }

    setIsSubmitting(true);
    const loadingId = notificationService.loading('Sending Message', 'Please wait while we send your message...');

    try {
      const result = await emailService.sendContactForm(formData);
      
      notificationService.removeNotification(loadingId);
      
      if (result.success) {
        notificationService.success('Message Sent!', result.message);
        // Reset form
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
      } else {
        notificationService.error('Sending Failed', result.message);
      }
    } catch (error) {
      notificationService.removeNotification(loadingId);
      notificationService.error('Sending Failed', 'An unexpected error occurred. Please try again.');
      console.error('Form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <div className="about-hero-content">
            <div className="hero-text">
              <h1>About Us</h1>
              <h2>Helping you amplify your global reach</h2>
              <p>We're here to turn your ambitions into reality</p>
              <p className="hero-description">
                Edugration is a leading Bangladeshi student recruitment agency helping 9,500+ students achieve their study abroad dreams in countries like Australia, Canada, Denmark, Finland, Ireland, New Zealand, Sweden, the USA, and the UK. We offer personalized support and tailored opportunities to meet your educational goals.
              </p>
              <Link to="/apply">
                <button className="btn btn-primary">
                  Get a free counseling
                  <i className="fas fa-arrow-right"></i>
                </button>
              </Link>
            </div>
            <div className="hero-image">
              <div className="image-placeholder">
                <i className="fas fa-graduation-cap"></i>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Milestone Section */}
      {/* <section className="milestone-section">
        <div className="container">
          <h2>Our Milestone</h2>
          <div className="milestone-grid">
            <div className="milestone-item">
              <div className="milestone-number">40,000+</div>
              <div className="milestone-label">Students Served</div>
              <div className="milestone-step">001</div>
            </div>
            <div className="milestone-item">
              <div className="milestone-number">230+</div>
              <div className="milestone-label">University Partners</div>
              <div className="milestone-step">002</div>
            </div>
            <div className="milestone-item">
              <div className="milestone-number">9,500+</div>
              <div className="milestone-label">Students Successfully Recruited</div>
              <div className="milestone-step">003</div>
            </div>
          </div>
        </div>
      </section> */}

      {/* How We Help Section */}
      <section className="help-section">
        <div className="container">
          <h2>How we help?</h2>
          <div className="help-grid">
            <div className="help-item">
              <div className="help-icon">
                <i className="fas fa-comments"></i>
              </div>
              <h3>Free Counseling</h3>
              <p>We offer personalized, free counseling sessions to help you choose the best study abroad options based on your academic goals, financial situation, and career aspirations.</p>
              <div className="help-step">01</div>
            </div>
            <div className="help-item">
              <div className="help-icon">
                <i className="fas fa-file-alt"></i>
              </div>
              <h3>Application Process</h3>
              <p>Our team assists with every aspect of the university admission process, from selecting the right institutions to completing and submitting your application, ensuring all requirements are met.</p>
              <div className="help-step">02</div>
            </div>
            <div className="help-item">
              <div className="help-icon">
                <i className="fas fa-passport"></i>
              </div>
              <h3>Visa Application</h3>
              <p>We guide you through the visa application process, providing support with documentation, financial statements, and preparation for visa interviews to increase your chances of approval.</p>
              <div className="help-step">03</div>
            </div>
            <div className="help-item">
              <div className="help-icon">
                <i className="fas fa-plane-departure"></i>
              </div>
              <h3>Pre-departure Briefing</h3>
              <p>Get ready for your adventure! Our briefing covers cultural insights, safety tips, accommodation advice, healthcare information, and more to ensure a smooth transition.</p>
              <div className="help-step">04</div>
            </div>
            <div className="help-item">
              <div className="help-icon">
                <i className="fas fa-hands-helping"></i>
              </div>
              <h3>Post-departure Support</h3>
              <p>We offer guardianship services for younger students, ensuring their safety and well-being while studying abroad. Our team stays in touch to provide ongoing support throughout their academic journey.</p>
              <div className="help-step">05</div>
            </div>
            <div className="help-item">
              <div className="help-icon">
                <i className="fas fa-shield-alt"></i>
              </div>
              <h3>Guardianship and Welfare Services</h3>
              <p>We offer guardianship services for younger students, ensuring their safety and well-being while studying abroad. Our team stays in touch to provide ongoing support throughout their academic journey.</p>
              <div className="help-step">06</div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission, Values, Vision Section */}
      <section className="belief-section">
        <div className="container">
          <h2>What we believe in</h2>
          <p className="belief-subtitle">Since 2001, Edugration has been inspiring students to excel</p>
          <div className="belief-tabs">
            <div className="belief-tab active">
              <h3>Mission</h3>
              <p>To empower students by providing comprehensive guidance and support, enabling them to achieve their educational and career goals abroad.</p>
              <div className="belief-step">01</div>
            </div>
            <div className="belief-tab">
              <h3>Values</h3>
              <ul>
                <li><strong>Integrity:</strong> We uphold honesty and transparency in all our services.</li>
                <li><strong>Excellence:</strong> We strive for the highest quality in every aspect of our work.</li>
                <li><strong>Student-Centric:</strong> Our focus is always on the best interests of our students.</li>
                <li><strong>Commitment:</strong> We are dedicated to seeing our students succeed at every step.</li>
              </ul>
              <div className="belief-step">02</div>
            </div>
            <div className="belief-tab">
              <h3>Vision</h3>
              <p>To be the leading provider of study abroad services, recognized for transforming the lives of students through global education opportunities.</p>
              <div className="belief-step">03</div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      {/* <section className="testimonials-section">
        <div className="container">
          <h2>What our partners say</h2>
          <div className="testimonials-grid">
            <div className="testimonial-item">
              <div className="testimonial-content">
                <p>"Edugration has been an excellent partner in helping us connect with talented students from Bangladesh. Their professionalism and dedication to student success is commendable."</p>
              </div>
              <div className="testimonial-author">
                <div className="author-info">
                  <h4>Mr. John Smith</h4>
                  <p>Chief International Officer</p>
                  <p>Thompson Rivers University</p>
                </div>
              </div>
            </div>
            <div className="testimonial-item">
              <div className="testimonial-content">
                <p>"The quality of students referred by Edugration has been outstanding. They truly understand the needs of both students and universities."</p>
              </div>
              <div className="testimonial-author">
                <div className="author-info">
                  <h4>Ms. Sarah Johnson</h4>
                  <p>Student Recruitment Manager</p>
                  <p>Columbia College</p>
                </div>
              </div>
            </div>
            <div className="testimonial-item">
              <div className="testimonial-content">
                <p>"Edugration's comprehensive support system ensures students are well-prepared for their international education journey."</p>
              </div>
              <div className="testimonial-author">
                <div className="author-info">
                  <h4>Mr. David Wilson</h4>
                  <p>Business Development Manager</p>
                  <p>University of Niagara Falls</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Student Testimonials */}
      {/* <section className="student-testimonials">
        <div className="container">
          <h2>What Students say</h2>
          <div className="student-testimonials-grid">
            <div className="student-testimonial">
              <div className="student-content">
                <p>"Edugration made my dream of studying in Canada come true. Their guidance was invaluable throughout the entire process."</p>
              </div>
              <div className="student-info">
                <h4>Mahmuda Khatun Anamika</h4>
                <p>Master of Medical Biotechnology</p>
                <p>University of Windsor</p>
              </div>
            </div>
            <div className="student-testimonial">
              <div className="student-content">
                <p>"The support I received from Edugration was exceptional. They helped me secure admission to my dream university."</p>
              </div>
              <div className="student-info">
                <h4>Mohammad Sadman Sadaf</h4>
                <p>Bachelor of Business Administration</p>
                <p>Vancouver Island University</p>
              </div>
            </div>
            <div className="student-testimonial">
              <div className="student-content">
                <p>"Thanks to Edugration, I'm now pursuing my Computer Science degree in Canada. Their expertise made everything smooth."</p>
              </div>
              <div className="student-info">
                <h4>Nahin Afrin Nuha</h4>
                <p>Bachelor of Computer Science</p>
                <p>Algoma University</p>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Achievements Section */}
      {/* <section className="achievements-section">
        <div className="container">
          <h2>Our Achievements</h2>
          <div className="achievement-item">
            <div className="achievement-content">
              <h3>Progressive Partner Award</h3>
              <p>Global University Systems Canada</p>
              <span className="achievement-year">2024</span>
            </div>
          </div>
        </div>
      </section> */}

      {/* Partner Universities Section */}
      <section className="partners-section">
        <div className="container">
          <h2>Partner Universities</h2>
          <div className="partners-grid">
            <div className="partner-item">Thompson Rivers University</div>
            <div className="partner-item">Columbia College</div>
            <div className="partner-item">University of Windsor</div>
            <div className="partner-item">Vancouver Island University</div>
            <div className="partner-item">Algoma University</div>
            <div className="partner-item">University of Niagara Falls</div>
            <div className="partner-item">Navitas</div>
            <div className="partner-item">Global University Systems</div>
          </div>
        </div>
      </section>

      {/* Accreditation Section */}
      {/* <section className="accreditation-section">
        <div className="container">
          <h2>Member and Trained Agent of</h2>
          <div className="accreditation-item">
            <h3>ICEF Accredited</h3>
            <p>International Consultants for Education and Fairs</p>
          </div>
        </div>
      </section> */}

      {/* Contact Section */}
      <section className="contact-section">
        <div className="container">
          <div className="contact-form-container">
            <h3>Send us a Message</h3>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input 
                  type="text" 
                  id="name" 
                  name="name" 
                  value={formData.name}
                  onChange={handleChange}
                  required 
                  placeholder="Enter your full name"
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  value={formData.email}
                  onChange={handleChange}
                  required 
                  placeholder="Enter your email address"
                />
              </div>
              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <input 
                  type="text" 
                  id="subject" 
                  name="subject" 
                  value={formData.subject}
                  onChange={handleChange}
                  required 
                  placeholder="What's this about?"
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea 
                  id="message" 
                  name="message" 
                  rows="5" 
                  value={formData.message}
                  onChange={handleChange}
                  required 
                  placeholder="Tell us more about your study abroad goals..."
                ></textarea>
              </div>
              <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Send Message'}
                <i className={isSubmitting ? 'fas fa-spinner fa-spin' : 'fas fa-paper-plane'}></i>
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
